import fonts from './fonts';

export default {
  fonts,
  colors: {}
};

export const pathsToOverride = [
  'families.button.primary.main',
  'families.button.primary.light',
  'families.button.primary.dark',
  'colors.merchantColor',
  'families.banner.info.main',
  'families.button.secondary.text'
];

export const defaultTheme = {
  global: {
    fonts: [],
    hover: {
      boxShadow: ' 0 1.2rem 2rem rgb(0 0 0 / 15%)',
      boxShadowButton: 'inset 0 0 0 1000px rgba(0, 0, 0, 0.1)'
    },
    colors: {
      primary: 'rgb(42, 42, 43)'
    }
  },
  input: {
    base: {
      borderColor: '',
      borderRadius: '',
      backgroundColor: '',
      fontSize: '',
      fontWeight: '',
      fontFamily: '',
      color: ''
    },
    active: {
      borderColor: '',
      backgroundColor: '',
      color: '',
      labelColor: ''
    },
    error: {
      borderColor: '',
      backgroundColor: '',
      color: '',
      labelColor: ''
    },
    focus: {
      outline: ''
    },
    placeholder: {
      fontSize: '',
      fontWeight: '',
      fontFamily: '',
      color: ''
    },
    selection: {
      color: '',
      backgroundColor: ''
    },
    disabled: {
      backgroundColor: '',
      color: ''
    }
  },
  cardFields: {
    title: {
      color: ''
    },
    saveForFutureLabel: {
      color: ''
    },
    setAsDefaultLabel: {
      color: ''
    },
    subTitle: {
      color: ''
    }
  },
  orderDetails: {
    title: {
      color: ''
    },
    totalLabel: {
      color: ''
    },
    totalValue: {
      color: ''
    }
  },
  pciMessage: {
    color: ''
  },
  dropdown: {
    title: {
      color: ''
    },
    base: {
      fontSize: '',
      fontWeight: '',
      fontFamily: '',
      borderColor: '',
      backgroundColor: '',
      borderRadius: '',
      labelColor: '',
      color: ''
    },
    active: {
      borderColor: '',
      backgroundColor: '',
      labelColor: '',
      color: ''
    },
    error: {
      borderColor: '',
      backgroundColor: '',
      labelColor: '',
      color: ''
    },
    focus: {
      outline: ''
    },
    placeholder: {
      fontSize: '',
      fontWeight: '',
      fontFamily: '',
      color: ''
    },
    disabled: {
      backgroundColor: '',
      color: ''
    },
    item: {
      transition: '',
      base: {
        backgroundColor: '',
        color: '',
        fontFamily: ''
      },
      hover: {
        backgroundColor: '',
        color: '',
        fontFamily: ''
      },
      selected: { backgroundColor: '', color: '', fontFamily: '' }
    },
    list: {
      backgroundColor: '',
      border: '',
      borderRadius: '',
      boxShadow: ''
    }
  },
  submit: {
    transition: '',
    base: {
      backgroundColor: '',
      color: '',
      fontWeight: '',
      fontSize: '',
      fontFamily: '',
      border: '',
      borderRadius: '',
      boxShadow: '',
      width: '',
      height: '',
      padding: '',
      cursor: ''
    },
    hover: {
      backgroundColor: '',
      color: '',
      fontWeight: '',
      border: '',
      borderRadius: '',
      boxShadow: ''
    },
    active: {
      backgroundColor: '',
      color: ''
    }
  },
  clear: {
    transition: '',
    base: {
      width: '',
      height: '',
      padding: '',
      borderRadius: '',
      backgroundColor: '',
      cursor: ''
    },
    hover: {
      backgroundColor: ''
    },
    active: { backgroundColor: '' }
  },
  tooltip: {
    button: {
      transition: '',
      base: {
        width: '',
        height: '',
        padding: '',
        border: '',
        borderRadius: '',
        backgroundColor: ''
      },
      hover: {
        border: '',
        borderRadius: '',
        backgroundColor: ''
      },
      active: {
        border: '',
        borderRadius: '',
        backgroundColor: ''
      }
    },
    content: {
      base: {
        padding: '',
        border: '',
        borderRadius: '',
        boxShadow: '',
        backgroundColor: ''
      }
    }
  },
  cart: {
    description: {
      fontSize: '',
      fontWeight: '',
      color: ''
    },
    amount: {
      fontSize: '',
      fontWeight: '',
      color: ''
    },
    quantityTitle: {
      fontSize: '',
      fontWeight: '',
      color: ''
    },
    quantityValue: {
      fontSize: '',
      fontWeight: '',
      color: ''
    },
    image: {
      transition: '',
      width: '',
      height: '',
      border: '',
      borderRadius: '',
      hover: {
        border: '',
        borderRadius: ''
      },
      focus: {
        outline: ''
      }
    }
  },
  instructions: {
    title: {
      color: ''
    },
    text: {
      color: ''
    },
    numbering: {
      background: '',
      text: ''
    }
  }
};
